import Fetcher from '../../../../services/Fetcher'
import {
  API_DICTIONARY,
  HTTP_METHODS,
  ResponseWithPagination,
  TOptionsResponse
} from '../../../../constants'
import { CognusAdminData, CognusAdminTableRequest } from './types'

const fetcher = new Fetcher({})

export const getAdminARTableData = async (data) =>
  fetcher.request<
    CognusAdminTableRequest,
    ResponseWithPagination<CognusAdminData>
  >({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.ADMIN_FEE_DASHBOARD}${API_DICTIONARY.ACCOUNTS_RECEIVABLE}${API_DICTIONARY.ADMIN_FEES}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const getAdminAPTableData = async (data) =>
  fetcher.request<
    CognusAdminTableRequest,
    ResponseWithPagination<CognusAdminData>
  >({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.ADMIN_FEE_DASHBOARD}${API_DICTIONARY.ACCOUNTS_PAYABLE}${API_DICTIONARY.ADMIN_FEES}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const getVendorFilterOptions = async () =>
  fetcher.request<unknown, unknown>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.ADMIN_FEE_DASHBOARD}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.VENDORS}`,
    method: HTTP_METHODS.GET
  })

export const getHSFilterOptions = async () =>
  fetcher.request<unknown, ResponseWithPagination<TOptionsResponse>>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.ADMIN_FEE_DASHBOARD}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.HEALTH_SYSTEMS}`,
    method: HTTP_METHODS.GET
  })

export const getPayorFilterOptions = async () =>
  fetcher.request<unknown, ResponseWithPagination<TOptionsResponse>>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.ADMIN_FEE_DASHBOARD}${API_DICTIONARY.ACCOUNTS_RECEIVABLE}${API_DICTIONARY.ADMIN_FEES}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.PAYORS}`,
    method: HTTP_METHODS.GET
  })
